import '../styles/HomeTeamSlider.scss';
import 'swiper/css';
import 'swiper/css/free-mode';

import {Swiper, SwiperSlide} from 'swiper/react';
import {FreeMode, Mousewheel} from "swiper/modules";
import Loading from "./Loading";
import AvatarCard from "./AvatarCard";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {NodeServer, TeamCollectionName} from "../config";
import axios from "axios";
import {useInView} from "react-intersection-observer";

interface TeamItem {
    nftId: number;
    image: string;
    name: string;
    occupationName: string;
}

export const HomeTeamSlider = () => {
    const [loading, setLoading] = useState(true);
    const [teamCards, setTeamCards] = useState([] as TeamItem[]);

    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.4
    })

    const navigate = useNavigate();

    const onAvatarClick = (nftId: number) => {
        navigate(`/avatar?id=${nftId}`);
    };

    useEffect(() => {
        const getTeam = async () => {
            const response = await axios.get<any>(
                `${NodeServer.baseURL}${NodeServer.teamGallery}${TeamCollectionName}`,
                { withCredentials: true }
            );

            // TODO: used for local debug and develop
            // const response = {
            //     data: [
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/0.png",
            //             "name": "Anna Sher",
            //             "occupationName": "Immersive Entrepreneur",
            //             "nftId": 0
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/1.png",
            //             "name": "Den Nich",
            //             "occupationName": "Creative Director",
            //             "nftId": 1
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/2.png",
            //             "name": "Igrek",
            //             "occupationName": "Metaverse Cringineer",
            //             "nftId": 2
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/3.png",
            //             "name": "Liza Nest",
            //             "occupationName": "Volumetric Creator",
            //             "nftId": 3
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/4.png",
            //             "name": "Igor Merch",
            //             "occupationName": "Application Face Sculptor",
            //             "nftId": 4
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/5.png",
            //             "name": "Olha Teren",
            //             "occupationName": "Metaverse Guide",
            //             "nftId": 5
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/6.png",
            //             "name": "Dmitro Lev",
            //             "occupationName": "Metaverse Voodoo Master",
            //             "nftId": 6
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/7.png",
            //             "name": "0xWysocki",
            //             "occupationName": "Machine Brain Engineer",
            //             "nftId": 7
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/8.png",
            //             "name": "Fabler",
            //             "occupationName": "Digitalizer",
            //             "nftId": 8
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/9.png",
            //             "name": "Rom Bur",
            //             "occupationName": "Cloud Guard",
            //             "nftId": 9
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/10.png",
            //             "name": "Oleg Dem",
            //             "occupationName": "Multidimensional Implementor",
            //             "nftId": 10
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/11.png",
            //             "name": "7a",
            //             "occupationName": "Psychokinetic Dreamer",
            //             "nftId": 11
            //         },
            //         {
            //             "image": "https://fortuneTeller.softserveinc.com/blob/images/57.png",
            //             "name": "Mr3ddi",
            //             "occupationName": "Error Detective",
            //             "nftId": 57
            //         }
            //     ]
            // }
            const cardsArr = response?.data as TeamItem[];
            if (cardsArr) {
                const sortedTeam = cardsArr.sort((a, b) =>
                    a.nftId > b.nftId ? 1 : -1
                );
                setTeamCards(sortedTeam);
            }
            setLoading(false);
        };
        try {
            getTeam();
        } catch (error) {
            setLoading(false);
        }
    }, []);

    return <>
        <div ref={ref} className={inView ? 'home-team-slider-section slideInUp' : 'home-team-slider-section'}>
            <div className="section-shadow section-shadow-from-top"></div>
            <div className='home-team-slider-wrapper'>
                <h2 className="block-title">WE KNOW, <br />YOU COULD TOO </h2>
                <h3 className="block-subtitle">
                    We, immersive experiences creators from Softserve formed initiative group to find out what will be
                    waiting for us in the future digital world. We summoned Alnair and he predicted our future. And you
                    decide if you want to know yours.
                </h3>
            </div>
        </div>
        <div className="slider-wrapper">
            {loading ? (
                <div className="loading-container">
                    <Loading/>
                </div>
            ) : (
                <Swiper
                    slidesPerView="auto"
                    slidesOffsetAfter={20}
                    slidesOffsetBefore={20}
                    spaceBetween={30}
                    freeMode={true}
                    mousewheel={{
                        forceToAxis: true,
                    }}
                    modules={[FreeMode, Mousewheel]}
                >
                    {teamCards.map((card, index) => (
                        <SwiperSlide key={index}>
                            <AvatarCard
                                onClick={() => onAvatarClick(card.nftId)}
                                item={card}
                            />
                        </SwiperSlide>

                    ))}
                </Swiper>
            )}

            <div className="swiper-footer">
                <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
                    <path
                        d="M37.2966 16.7729H34.8246C28.9486 16.7729 24.1406 21.5809 24.1406 27.4569V44.3899C24.1406 50.2659 28.9486 55.074 34.8246 55.074H37.2966C43.1726 55.074 47.9806 50.2659 47.9806 44.3899V27.4569C47.9806 21.5809 43.1726 16.7729 37.2966 16.7729Z"
                        fill="#D0CFCE"/>
                    <path
                        d="M36.0623 22.1121C35.5127 22.1136 34.9861 22.3327 34.5975 22.7213C34.2089 23.1099 33.9899 23.6365 33.9883 24.1861V30.0201C33.9901 30.5695 34.2093 31.0958 34.5978 31.4842C34.9864 31.8726 35.5129 32.0915 36.0623 32.0931C36.6117 32.0915 37.1381 31.8726 37.5267 31.4842C37.9153 31.0958 38.1344 30.5695 38.1363 30.0201V24.1861C38.1347 23.6365 37.9157 23.1099 37.5271 22.7213C37.1385 22.3327 36.6119 22.1136 36.0623 22.1121Z"
                        fill="#3F3F3F"/>
                    <path
                        d="M35.1344 18.1769C38.1614 19.4759 41.0384 21.3399 41.3734 26.0499C41.7614 31.5049 39.7434 41.7189 39.0934 46.9069C38.6404 50.5339 36.8464 52.2139 34.4634 54.1169C33.2634 55.0779 39.7304 54.9609 42.3934 53.4039C44.6794 52.0679 46.8934 49.7749 46.9204 50.4999L47.2434 24.6949C47.2434 24.6949 46.3064 17.7579 38.6774 17.7549C38.6774 17.7549 31.0254 17.3619 35.1344 18.1769Z"
                        fill="#9B9B9A"/>
                    <path
                        d="M38.8298 54.5009H33.2928C28.3228 54.5009 24.2578 50.4359 24.2578 45.4669V26.3799C24.2578 21.4109 28.3238 17.3459 33.2928 17.3459H38.8288C43.7988 17.3459 47.8638 21.4109 47.8638 26.3799V45.4669C47.8638 50.4359 43.7978 54.5009 38.8288 54.5009H38.8298Z"
                        stroke="black" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"
                        strokeLinejoin="round"/>
                    <path
                        d="M57.1554 34.191L62.3714 28.975M36.1444 32.155H35.9764C35.4384 32.1537 34.9228 31.9394 34.5424 31.559C34.162 31.1786 33.9477 30.663 33.9464 30.125V24.08C33.9464 22.964 34.8604 22.051 35.9764 22.051H36.1444C37.2604 22.051 38.1744 22.964 38.1744 24.081V30.127C38.1744 31.243 37.2604 32.157 36.1444 32.157V32.155ZM15.0314 34.191L9.81641 28.975L15.0314 34.191ZM15.0314 23.717L9.81641 28.933L15.0314 23.717ZM57.1554 23.717L62.3714 28.933L57.1554 23.717Z"
                        stroke="#EDEDED" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"
                        strokeLinejoin="round"/>
                </svg>
            </div>
            <div className="section-shadow section-shadow-from-bottom"></div>
        </div>
    </>
}